var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPremiumFeatures(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4796 2.19418L14.2394 5.74288C14.4794 6.23687 15.1193 6.7107 15.6593 6.80143L18.8489 7.33575C20.8887 7.67853 21.3687 9.1706 19.8988 10.6425L17.4191 13.1427C16.9991 13.5661 16.7692 14.3827 16.8991 14.9675L17.6091 18.0625C18.169 20.5123 16.8791 21.46 14.7294 20.1796L11.7397 18.3952C11.1998 18.0726 10.3099 18.0726 9.75985 18.3952L6.77022 20.1796C4.63045 21.46 3.3306 20.5022 3.89054 18.0625L4.60046 14.9675C4.73044 14.3827 4.50047 13.5661 4.08051 13.1427L1.60079 10.6425C0.140952 9.1706 0.610903 7.67853 2.65067 7.33575L5.84032 6.80143C6.37026 6.7107 7.01019 6.23687 7.25016 5.74288L9.00995 2.19418C9.96985 0.268607 11.5297 0.268607 12.4796 2.19418Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumFeatures);
export default __webpack_public_path__ + "static/media/PremiumFeatures.df49adb8b7ce7fb5c5344f3bf86a1a24.svg";
export { ForwardRef as ReactComponent };